import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=211fb7e7&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=211fb7e7&prod&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=211fb7e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211fb7e7",
  null
  
)

export default component.exports